// 解析内容，进行内容分组
export const execData = (str: string) => {
  if (!str) {
    return {
      match: '',
      text: '',
    };
  }
  const regex = /【(.*?)】/g;
  const mater = str.match(regex);
  let result = str.replace(regex, '');

  // 新增文字配音匹配，匹配 ## 开头的内容
  const regex2 = /^(.*?)##(.*)$/;
  const matchResult = result.match(regex2);
  const textDubUrlName = matchResult?.[2]?.trim() || '';

  if (textDubUrlName) {
    result = matchResult?.[1] || '';
  }

  return {
    match: mater?.[0] || '',
    text: result,
    textDubUrlName,
  };
};
